import React from 'react'
import { css, useTheme } from '@emotion/react'
import { Card, Typography, Button } from '../base-ui'
import { MediaQuery } from '../base-ui/Utility'
import Link from 'next/link'
import { generateUrl } from '../../utils'

export default function Brokercard({ broker = {} }) {
    const theme = useTheme()
    const link = generateUrl(broker, 'broker')
    return (
        <Link href={link}>
            <a>
                <Card
                    type="horizental"
                    imgSrc={
                        broker?.logo?.hash &&
                        `/api/filedb/${broker.logo.hash}.${broker.logo.ext}`
                    }
                    imgWidth={200}
                    imgHeight={200}
                    bordered
                    imgFullRound={true}
                    className="relative"
                    style={`.card-footer {
                ${MediaQuery('lg', 'max')} {
                    display: none;
                }
            }
            
            ${MediaQuery('md', 'max')} {
                flex-direction: column;
                align-items: center;
            }
            `}
                    title={
                        <Typography
                            type="h4"
                            fontWeight="Bold"
                            align="left"
                            style={`${MediaQuery('md', 'max')} {font-size: ${
                                theme.fontSize.lg
                            }; text-align:center;}`}
                        >
                            {broker.title}
                        </Typography>
                    }
                    // footer={
                    //     <Button
                    //         backgroundColor="secondary"
                    //         color="lighterGray"
                    //         className="lg:mr-auto lg:ml-0 mx-auto"
                    //     >
                    //         باز کردن اکانت
                    //     </Button>
                    // }
                >
                    <div
                        className="flex flex-wrap justify-center lg:justify-start lg:pt-4 pt-2"
                        dir="ltr"
                    >
                        <div className="lg:flex lg:flex-col text-left lg:flex-wrap lg:pr-4 basis-1/2">
                            {broker.attrs_list_page?.map((a, i) => (
                                <React.Fragment key={i}>
                                    <Typography
                                        type="h6"
                                        align="left"
                                        style={`${MediaQuery('md', 'max')} {
                        font-size: ${theme.fontSize.base};
                        padding-top:0.5rem;
                    }`}
                                    >
                                        {a.key}
                                    </Typography>
                                    <span
                                        css={css`
                                            ${MediaQuery('md', 'max')} {
                                                font-size: ${theme.fontSize.sm};
                                            }
                                        `}
                                    >
                                        {a.value}
                                    </span>
                                </React.Fragment>
                            ))}
                        </div>

                        <Button
                            backgroundColor="secondary"
                            color="lighterGray"
                            className="mr-auto"
                            style={`${MediaQuery('lg', 'min')} {
                    display: none;
                }; ${MediaQuery('md', 'max')} {font-size: ${theme.fontSize.sm};
                    flex-basis: 100%;
                    flex-grow: 2;
                    margin-top: 1rem;
                };`}
                        >
                            باز کردن اکانت
                        </Button>
                    </div>
                </Card>
            </a>
        </Link>
    )
}
